import * as amplitude from '@amplitude/analytics-browser';

import { EVENT_TYPES } from '@/shared/constants/events';
import { sendEventService } from '@/shared/services/events.service';
import { getEventSource } from '@/shared/utils/general.util';
import { type AppUpdatePrompt } from './appUpdateDecision';

type AppUpdateEvent =
	| typeof EVENT_TYPES.APP_UPDATE_PROMPT_SHOWN
	| typeof EVENT_TYPES.APP_UPDATE_STORE_OPENED
	| typeof EVENT_TYPES.APP_UPDATE_PROMPT_DISMISSED;

/**
 * Sent without the router-bound `useEvents` because the gate lives above the router:
 * to our events service and to Amplitude, the same destinations and `source` as `useEvents`.
 */
export const trackAppUpdate = (event: AppUpdateEvent, prompt: AppUpdatePrompt): void => {
	if (prompt.forced || prompt.simulated) return;
	const source = getEventSource(true);
	const eventPayload = {
		mode: prompt.mode,
		platform: prompt.platform,
		app_version: prompt.appVersion,
		threshold: prompt.threshold,
	};
	sendEventService({ event, source, eventPayload }).catch(() => {});
	try {
		amplitude.track(event, { ...eventPayload, source });
	} catch {
		// Analytics must never break the update prompt.
	}
};
